export default __webpack_public_path__ + "locales/sr-Latn-RS/FilesSettings.json?hash=7384073910349a83340643b17474a9cc";